<div class="flex flex-wrap gap-5 justify-center my-8">
    <div *ngFor="let card of cards" class="feature-card">
        <img [src]="card.image?.url" [alt]="translateHelper.localize(card.title)??'mini-feature-card'">
        <h3>{{translateHelper.localize(card.title)}}</h3>
        <small>{{translateHelper.localize(card.subtitle)}}</small>
    </div>
</div>
